// extracted by mini-css-extract-plugin
module.exports = {"page":"ConsentsPage_page__3p_nH","title":"ConsentsPage_title__POJ05"};